import React from 'react'
import Button from 'app/app/(client)/components/atoms/Button/Button'
import Card from 'app/app/(client)/components/atoms/Card/Card'
import Icon from 'app/app/(client)/components/atoms/Icon/Icon'
import ButtonwithSpinner from 'app/app/(client)/components/molecules/ButtonwithSpinner/ButtonwithSpinner'
import { useAppDispatch, useAppSelector } from 'app/app/(client)/hooks/redux-hook'
import { getIcon } from 'app/app/(client)/utils/utils'
import { hideAlert } from '../../../redux/features/notification/alert-slice'

const AlertBox: React.FC = () => {
  const dispatch = useAppDispatch()
  const {
    type,
    title,
    description,
    isVisible,
    id,
    isDismissOnBackdrop,
    isLoadingPrimaryButton,
    onClose,
    onSecondaryClick,
    secondaryButtonContent,
    onPrimaryClick,
    primaryButtonContent,
    deactivateCloseButton
  } = useAppSelector(state => state.alert)

  if (!isVisible) {
    return null
  }

  const handleOnClose = () => {
    if (onClose) {
      onClose()
    }
    dispatch(hideAlert())
  }

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget && isDismissOnBackdrop) {
      handleOnClose()
    }
  }

  const headContent = (
    <div className={`flex items-center justify-between ${type === 'modal' ? 'pl-4 pt-4 pr-4' : ''}`}>
      <div className="flex gap-2 items-center">
        <Icon name={getIcon(type)} className={`text-24px alert-box__icon--${type}`} />
        <span className="text-20px/[32px] font-semibold">{title}</span>
      </div>

      <Button
        id={`${id}-close-button`}
        variant="tertiary"
        size="small"
        className="btn-icon flex !p-1 !min-w-0 !h-8 !w-8"
        onClick={handleOnClose}
        aria-label="Close"
        disabled={deactivateCloseButton}
      >
        <Icon name="icon-close-cross" className="text-black text-24px" />
      </Button>
    </div>
  )

  const footerContent = (
    <div className={`flex flex-row justify-end gap-4 ${type === 'modal' ? ' pb-4 pr-4' : ''}`}>
      {onSecondaryClick && (
        <Button
          id={`${id}-secondary-button`}
          onClick={onSecondaryClick}
          variant={'secondary'}
          size="xsmall"
          className="btn !min-w-20"
          disabled={false}
        >
          {secondaryButtonContent}
        </Button>
      )}

      {onPrimaryClick && (
        <ButtonwithSpinner
          id={`${id}-primary-button`}
          variant="primary"
          size="xsmall"
          className="btn !min-w-20"
          onClick={onPrimaryClick}
          loading={isLoadingPrimaryButton}
        >
          {primaryButtonContent}
        </ButtonwithSpinner>
      )}
    </div>
  )

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-background-transparent-black p-2 md:p-0"
      onClick={handleBackdropClick}
      data-testid="alertBox-backdrop"
      role="alertdialog"
    >
      <Card
        id={`${id}-modal-card`}
        header={headContent}
        footer={footerContent}
        className={`!shadow-large p-4 min-w-[336px] max-w-[488px] alert-box--${type}`}
      >
        <div className="font-kone text-14px/[24px] text-disabled pl-8 pr-8">{description}</div>
      </Card>
    </div>
  )
}

export default AlertBox
